import { Link } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useCartModal } from "@/context/CartModalContext";
import { CartContext } from "@/context/CartContext";
import BurgerMenu from "@/components/BurgerMenu/BurgerMenu";
import LanguageSwitcher from "@/components/LanguageSwitcher/LanguageSwitcher";
import styles from "./Nav.module.scss";

const Nav = () => {
  const { t } = useTranslation("common");
  const { openCart } = useCartModal();
  const { cart } = useContext(CartContext) || { cart: [] };
  const [cartCount, setCartCount] = useState<number>(0);

  useEffect(() => {
    const totalItems = cart.reduce(
      (acc: number, item: { quantity: number }) => acc + item.quantity,
      0
    );
    setCartCount(totalItems);
  }, [cart]);

  const [isBurgerOpen, setBurgerOpen] = useState(false);

  return (
    <div className={styles.navSection}>
      <BurgerMenu isOpen={isBurgerOpen} onClose={() => setBurgerOpen(false)} />
      <div className="container">
        <div className={styles.navBlock}>
          <Link to="/" className={styles.logo}>
            <img src="/images/site-logo.svg" alt="HIXA Logo" />
          </Link>
          <nav className={styles.nav} aria-label={t("nav.menu")}>
            <div className={styles.firtLink}>
              <div className={styles.linkMenu}>
                <Link to="/">{t("nav.services")}</Link>
                <button aria-label={t("common.expand")}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 12 12"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M1.50002 4L6.00002 8L10.5 4"
                      strokeWidth="1.5"
                      stroke="#4d4d4d"
                    />
                  </svg>
                </button>
              </div>
              <div className={styles.linkSubmenu}>
                <Link to="/services/berlin">{t("nav.workshopBerlin")}</Link>
                <Link to="/services/eu">{t("nav.postShipping")}</Link>
              </div>
            </div>
            <Link to="/shop">{t("nav.shop")}</Link>
            <Link to="/about-us">{t("nav.about")}</Link>
            <Link to="/partners">{t("nav.partner")}</Link>
            <Link to="/career">{t("nav.career")}</Link>
            <Link to="/faq">{t("nav.faq")}</Link>
            <Link to="/contact">{t("nav.contact")}</Link>
          </nav>
          <button
            className={styles.burger}
            aria-label={t("nav.menu")}
            onClick={() => setBurgerOpen(!isBurgerOpen)}
          >
            <span className={styles.bar} />
            <span className={styles.bar} />
            <span className={styles.bar} />
          </button>
          
          {/* Пошук + Перемикач мови */}
          <div className={styles.searchLang}>
            <button className={styles.search} aria-label={t("nav.search") || "Search"}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <circle cx="11" cy="11" r="7" stroke="#4d4d4d" strokeWidth="2" />
                <path d="M16.5 16.5L21 21" stroke="#4d4d4d" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </button>
            <LanguageSwitcher />
          </div>
          
          <button
            className={styles.cart}
            onClick={openCart}
            aria-label={t("cart.title")}
          >
            <svg
              className="fill"
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              aria-hidden="true"
            >
              <path
                fill="#4d4d4d"
                d="M5.459 4a4 4 0 0 1 3.72 2.531l6.252 15.836a1 1 0 0 0 .93.633h10.23a1 1 0 0 0 .941-.664l3.572-10A1 1 0 0 0 30.162 11H14a1 1 0 1 1 0-2h16.162c2.075 0 3.523 2.055 2.825 4.009l-3.571 10A3 3 0 0 1 26.591 25H16.36a3 3 0 0 1-2.79-1.898L7.318 7.266A2 2 0 0 0 5.46 6H3a1 1 0 0 1 0-2h2.459Z"
              />
              <circle cx="15" cy="29" r="2" fill="#4d4d4d" />
              <circle cx="28" cy="29" r="2" fill="#4d4d4d" />
            </svg>
            {cartCount > 0 && (
              <span className={styles.cartCount}>{cartCount}</span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Nav;
